import { useTheme, ThemePreference } from '../../context/ThemeContext'
import { useUser } from '../../context/UserContext'
import styles from './NavSidebar.module.css'

const themeIcons: Record<ThemePreference, string> = {
  light: '☀️',
  dark: '🌙',
  system: '💻',
}

const themeCycle: ThemePreference[] = ['system', 'light', 'dark']

interface NavSidebarProps {
  currentPage: string
  isAuthenticated: boolean
  isLoggedIn: boolean
}

export default function NavSidebar({ currentPage, isAuthenticated, isLoggedIn }: NavSidebarProps) {
  const { requireApiKeys } = useUser()
  const hasAnyKey = !requireApiKeys || isLoggedIn || isAuthenticated
  const { preference, setPreference } = useTheme()
  const sessionsActive = currentPage === 'sessions' || currentPage === 'session-detail'
  const auditActive = currentPage === 'audit' || currentPage === 'audit-detail'
  const charactersActive = currentPage === 'characters' || currentPage === 'character-detail'
  const prefabsActive = currentPage === 'prefabs' || currentPage === 'prefab-detail'
  const cachedResponsesActive = currentPage === 'cached-responses' || currentPage === 'cached-response-detail'

  function cycleTheme() {
    const idx = themeCycle.indexOf(preference)
    setPreference(themeCycle[(idx + 1) % themeCycle.length])
  }

  return (
    <nav className={styles.nav}>
      <div className={styles.logo}>⚡</div>
      <a href="#home" className={`${styles.item} ${currentPage === 'home' ? styles.active : ''}`}>
        Home
      </a>
      {hasAnyKey && (
        <>
          <a href="#chat" className={`${styles.item} ${currentPage === 'chat' ? styles.active : ''}`}>
            Chat
          </a>
          <a href="#admin" className={`${styles.item} ${currentPage === 'admin' ? styles.active : ''}`}>
            Admin
          </a>
        </>
      )}
      {isAuthenticated && (
        <>
          <a href="#api-keys" className={`${styles.item} ${currentPage === 'api-keys' ? styles.active : ''}`}>
            API Keys
          </a>
          <a href="#sessions" className={`${styles.item} ${sessionsActive ? styles.active : ''}`}>
            Sessions
          </a>
          <a href="#audit" className={`${styles.item} ${auditActive ? styles.active : ''}`}>
            Audit
          </a>
          <a href="#stories" className={`${styles.item} ${currentPage === 'stories' ? styles.active : ''}`}>
            Stories
          </a>
          <a href="#characters" className={`${styles.item} ${charactersActive ? styles.active : ''}`}>
            Characters
          </a>
          <a href="#prefabs" className={`${styles.item} ${prefabsActive ? styles.active : ''}`}>
            Prefabs
          </a>
          <a href="#cached-responses" className={`${styles.item} ${cachedResponsesActive ? styles.active : ''}`}>
            Cached
          </a>
          <a href="#upload" className={`${styles.item} ${currentPage === 'upload' ? styles.active : ''}`}>
            Upload
          </a>
          <a href="#garage" className={`${styles.item} ${currentPage === 'garage' ? styles.active : ''}`}>
            Garage
          </a>
        </>
      )}
      <div className={styles.spacer} />
      <button
        className={styles.themeToggle}
        onClick={cycleTheme}
        title={`Theme: ${preference}`}
        aria-label={`Theme: ${preference}`}
      >
        {themeIcons[preference]}
      </button>
    </nav>
  )
}
